import * as React from 'react';
import { toPng } from 'html-to-image';

/** Decode a data URL directly to a Blob without an async fetch round-trip. */
function dataUrlToBlob(dataUrl: string): Blob {
  const [header = '', base64 = ''] = dataUrl.split(',');
  const mime = header.match(/:(.*?);/)?.[1] ?? 'image/png';
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let idx = 0; idx < binary.length; idx++) bytes[idx] = binary.charCodeAt(idx);
  return new Blob([bytes], { type: mime });
}

/**
 * Captures a DOM element as a 2x PNG blob via html-to-image.
 * Returns a stable capture function that resolves to a Blob or null on failure.
 */
export function useShareImage(ref: React.RefObject<HTMLDivElement | null>) {
  return React.useCallback(async (): Promise<Blob | null> => {
    if (!ref.current) return null;
    try {
      const dataUrl = await toPng(ref.current, {
        width: 320,
        height: 320,
        pixelRatio: 2,
        cacheBust: true,
      });
      return dataUrlToBlob(dataUrl);
    } catch {
      return null;
    }
  }, [ref]);
}
